<template>
  <div class="layout-no-auth-node">
    <span v-popover:popover class="layout-no-auth-node-content">{{ data.menuName }}（无权限）</span>
    <el-popover
      ref="popover"
      placement="top"
      width="200"
      trigger="hover">
      <div>
        <span>{{ data.menuName }}（无权限）</span>
        <span class="layout-no-auth-node-apply-auth" @click="applyAuth">申请权限</span>
      </div>
    </el-popover>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      applyAuth () {
        const { data } = this
        this.$router.push({
          path: '/oa/workflow/new-application/QXSQ-0003',
          query: {
            menuId: data.menuId,
            menuName: data.menuName, // 要传 菜单路由
            applyType: 'add'
          }
        })
      }
    }
  }
</script>

<style lang="scss">
.layout-no-auth-node {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.layout-no-auth-node-apply-auth {
  color: #6D2EF8;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/no-auth-node.vue